import {ACTION_URL, CLIENT_TABS} from "../Config/Variables";
import { jwtFetch } from "../utils/apiClient";
import {doSearch} from "../Config/Helper";
import {useState, useEffect} from "react";
import {Spinner, Modal} from "react-bootstrap";
import {format} from "date-fns";

const MarketingClients = (props) => {
  const tabParam = new URLSearchParams(window.location.search).get('tab');
  const [tab, setTab] = useState(
    CLIENT_TABS.map((item) => item.name).includes(tabParam) ? tabParam : CLIENT_TABS[0].name
  );
  const [columns, setColumns] = useState(null);
  const [data, setData] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [tableSearch, setTableSearch] = useState('');
  const [tableFilters, setTableFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showTableFilters, setShowTableFilters] = useState(false);

  useEffect(() => {
    const tabItem = CLIENT_TABS.find((item) => item.name === tab);
    if (tabItem) {
      getData(tabItem);
    }
    document.title = `${tab} - CuanCuan`;
    window.history.pushState({tab: tab}, '', `${window.location.pathname}?tab=${tab}`);
  }, [tab]);

  useEffect(() => {
    const base = doSearch(Array.isArray(data) ? data : [], tableSearch);
    if (!Array.isArray(tableFilters) || tableFilters.length === 0) {
      setTableData(base);
      return;
    }
    const filtered = base.filter((item) => {
      return tableFilters.every(({column, value}) => {
        if (!column || !value) return true;
        const raw = item?.[column];
        const hay = raw === null || raw === undefined ? '' : String(raw).toLowerCase();
        const q = String(value).toLowerCase().trim();
        return hay.includes(q);
      });
    });
    setTableData(filtered);
  }, [data, tableSearch, tableFilters]);
  
  const getData = async (tabItem) => {
    try {
      setIsLoading(true);
      const getDataFetch = await jwtFetch(ACTION_URL + tabItem.url, {
        method: "POST",
        headers: {"Content-Type": "application/json"}
      });
      const getDataResponse = await getDataFetch.json();
      if (getDataResponse.status === 200) {
        setColumns(tabItem.columns);
        setData(getDataResponse.data);
      } else {
        console.log(getDataResponse.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error in getData:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };

  const addTableFilter = () => {
    setTableFilters(prev => {
      const newFilters = [...prev];
      newFilters.push({column: '', value: ''});
      return newFilters;
    });
  };

  const changeTableFilter = (index, column, value) => {
    setTableFilters(prev => {
      const newFilters = [...prev];
      newFilters[index][column] = value;
      return newFilters;
    });
  };

  const removeTableFilter = (index) => {
    setTableFilters(prev => {
      const newFilters = [...prev];
      newFilters.splice(index, 1);
      return newFilters;
    });
  };

  return (
    <div id="marketing-clients">
      <section>
        <div className="d-flex justify-content-between mb-3">
          <div className="d-flex align-items-center">
            <a href="/dashboard">Dashboard</a>
            <span className="mx-3"><i className="bi bi-chevron-right"/></span>
            <a href="/report">Clients</a>
            <span className="mx-3"><i className="bi bi-chevron-right"/></span>
            <span>{`${tab}`}</span>
          </div>
          <div className="d-flex gap-2">
            <div className="btn-group" role="group">
              <button className={`btn ${tab === 'Company Groups' ? 'btn-secondary' : 'btn-outline-secondary '}`} onClick={() => setTab('Company Groups')}><i className="bi bi-building me-2"></i>Company Groups</button>
              <button className={`btn ${tab === 'Subsidiaries' ? 'btn-secondary' : 'btn-outline-secondary '}`} onClick={() => setTab('Subsidiaries')}><i className="bi bi-buildings me-2"></i>Subsidiaries</button>
              <button className={`btn ${tab === 'Contacts' ? 'btn-secondary' : 'btn-outline-secondary '}`} onClick={() => setTab('Contacts')}><i className="bi bi-people me-2"></i>Contacts</button>
            </div>
          </div>
        </div>
      </section>
      
      {isLoading ? <Spinner/> : (
        <section>
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="card border-1">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-18">{tab}</div>
                    <div className="d-flex align-items-center gap-2">
                      <div className="input-group search-box">
                        <input className="form-control" type="text" placeholder="Search" value={tableSearch} onChange={(e) => setTableSearch(e.target.value)} autoFocus/>
                        <button className="btn" type="button" onClick={() => setTableSearch('')}>{tableSearch ? <i className="bi bi-x-lg"/> : <i className="bi bi-search"/>}</button>
                      </div>
                      <div className="filter-box">
                        <button className="btn" type="button" onClick={() => setShowTableFilters(true)}>
                          <i className="bi bi-filter"/>
                        </button>
                        {tableFilters.some(f => f?.column && f?.value) && (
                          <span className="dot-danger"/>
                        )}
                      </div>
                    </div>
                  </div>
                  {tableData ? (
                    <div>
                      <div className="summary-box mb-3">
                        <p className="mb-1">
                          <span className="d-inline-block w-90">Total records</span>
                          <span className="d-inline-block w-20">:</span>
                          {tableData.length || 0}
                          {(tableSearch || (tableFilters.length > 0)) && (
                            ` (from ${data?.length || 0})`
                          )}
                        </p>
                        {(tableFilters.some(f => f?.column && f?.value) || (tableSearch?.trim())) && (
                          <p className="mb-1">
                            <span className="d-inline-block w-90">Filters</span>
                            <span className="d-inline-block w-20">:</span>
                            <span>
                              {[
                                ...tableFilters
                                  .filter(f => f?.column && f?.value)
                                  .map(filter => {
                                    const col = columns?.find(c => c.value === filter.column);
                                    return col?.header || filter.column;
                                  }),
                                ...(tableSearch?.trim() ? ['Search'] : []),
                              ].join(', ')}
                            </span>
                          </p>
                        )}
                      </div>
                      <div className="table-responsive">
                        <table className="table table-gold freeze-col-2">
                          <thead>
                            <tr>
                              <th className="w-30">#</th>
                              {columns.map((row, r) => (
                                <th className={row.align === 'end' ? `text-end w-${row.width}` : `w-${row.width}`} key={`header-${r}`}>
                                  {row.header}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {tableData && (
                              tableData.map((item, i) => (
                                <tr key={`row-${i}`}>
                                  <td>{i + 1}</td>
                                  {columns.map((row, r) => (
                                    <td className={row.align === 'end' ? `text-end` : ''} key={`value-${r}`}>
                                      {row.type === 'string' && item[row.value]}
                                      {row.type === 'number' && Number(item[row.value])}
                                      {row.type === 'date' && (item[row.value] ? format(new Date(item[row.value]), 'd MMM yyyy') : '')}
                                      {row.type === 'datetime' && (item[row.value] ? format(new Date(item[row.value]), 'd MMM yyyy HH:mm:ss') : '')}
                                    </td>
                                  ))}
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : <Spinner/>}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
                
      <Modal show={showTableFilters} onHide={() => setShowTableFilters(false)}>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <strong className="fs-14">Filters</strong>
            <button className="btn btn-link" type="button" onClick={() => setShowTableFilters(false)}><i className="bi bi-x-lg"/></button>
          </div>
          <form>
            {tableFilters.map((filter, f) => {
              return (
                <div className="row align-items-baseline form-group mb-3 g-2" key={"filter-" + f}>
                  <div className="col-md-4">
                    <select className="form-select" value={filter.column} onChange={(e) => changeTableFilter(f, 'column', e.target.value)} required>
                      <option value=""></option>
                      {columns?.map((row, r) => (
                        <option value={row.value} key={`column-${r}`}>{row.header}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-7">
                    <input className="form-control" type="text" value={filter.value} onChange={(e) => changeTableFilter(f, 'value', e.target.value)} required/>
                  </div>
                  <div className="col-md-1">
                    <button className="btn btn-sm btn-link" onClick={() => removeTableFilter(f)}><i className="bi bi-dash-lg"></i></button>
                  </div>
                </div>
              );
            })}
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" type="button" onClick={() => addTableFilter()}>Add Filter</button>
              <button className="btn btn-link text-danger" type="button" onClick={() => setTableFilters([])}>Reset</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MarketingClients;
